// react library imports
import { useState, useEffect } from "react";

// import from component
import { Search } from "Component";

// import from apis
import { useLazyGetSkillListQuery, useGetSkillListQuery } from "api/other/other";

// imports from utils
import { debounce } from "Utils/common";

const SkillField = ({value, onChange}) => {
    // set state for query and showList
    const [query, setQuery] = useState("")
    const [showList, setShowList] = useState(false)    

    // fetch data  from backend using rtk query based on the value coming as a props
    const {data, isSuccess} = useGetSkillListQuery({skill_id:value})    

    // change state of query base on the api
    useEffect(()=>{
        if (data) {
            setQuery(data?.skills?.title)
        }
    }, [isSuccess, data])

    // fetch data from backend server using rtk query
    const [triggerSearch, { data: results, isFetching }] = useLazyGetSkillListQuery();
        
     // handle change in query
    const handleQueryChange = (e) => {
        const value = e.target.value;
        setQuery(value);
        if (value) {
            setShowList(true);
        } else {
            setShowList(false);
        }
    };

    // handle onclick event of search
    const handleInputChange = (e)=>{
        setQuery(e.title)                
        setShowList(false)
        if (onChange) {
            onChange(e?.id)
        }
    }

    // useEffect from less api request
    useEffect(() => {
        // Inline debounced function inside useEffect
        const debounceSearch = debounce((searchTerm) => {
            if (searchTerm) {
                triggerSearch({title:searchTerm});
            }
        }, 1000);        
        debounceSearch(query);
    }, [query, triggerSearch]);
    return (
        <Search placeholder="Skill" query={query} onChange={handleQueryChange} onClick={handleInputChange}
        showList={showList} list={results?.skills} loading={isFetching}/>
    )
}

export default SkillField